import React from 'react';
const StaticContext = React.createContext({});
const useStaticContext = () => {
    return React.useContext(StaticContext);
};
export { StaticContext, useStaticContext };
